import API from './api';

export const analyticsService = {
  // Get all analytics data (recommended - single API call)
  getAllAnalytics: async (startDate, endDate) => {
    try {
      const response = await API.get('/api/trips/admin/analytics/all', {
        params: { startDate, endDate }
      });
      
      console.log('API Raw Response:', response); // Debug log
      console.log('Response Data:', response.data); // Debug log
      
      // Handle the nested data structure: response.data.data
      if (response.data.success && response.data.data) {
        return {
          success: true,
          data: response.data.data // Extract the nested data
        };
      }
      
      return {
        success: false,
        message: response.data.message || 'No data received',
        error: response.data
      };
    } catch (error) {
      console.error('Analytics Service Error:', error); // Debug log
      return {
        success: false,
        message: error.response?.data?.message || error.response?.data?.error || 'Failed to fetch analytics data',
        error: error.response?.data
      };
    }
  },

  // Individual endpoint methods (fallback)
  getMetrics: async (startDate, endDate) => {
    try {
      const response = await API.get('/api/trips/admin/analytics/metrics', {
        params: { startDate, endDate }
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch metrics',
        error: error.response?.data
      };
    }
  },

  getUserGrowth: async (startDate, endDate) => {
    try {
      const response = await API.get('/api/trips/admin/analytics/growth', {
        params: { startDate, endDate }
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch user growth',
        error: error.response?.data
      };
    }
  },

  getUserActivity: async (startDate, endDate) => {
    try {
      const response = await API.get('/api/trips/admin/analytics/activity', {
        params: { startDate, endDate }
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch user activity',
        error: error.response?.data
      };
    }
  },

  getUserEngagement: async () => {
    try {
      const response = await API.get('/api/trips/admin/analytics/engagement');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch user engagement',
        error: error.response?.data
      };
    }
  },

  getRecentUsers: async (startDate, endDate, limit = 50) => {
    try {
      const response = await API.get('/api/trips/admin/analytics/users', {
        params: { startDate, endDate, limit }
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch recent users',
        error: error.response?.data
      };
    }
  }
};
